<template>
  <div>
    <card class="card" title="Application Tokens">
      <p class="mb-5">Tokens you have generated that can be used to access the VividLeaf API.</p>
      <div v-if="newToken" class="row">
        <p-button type="info" outline class="mb-3" @click.native.prevent="copyText(newToken.access_token)">
          Make sure to copy your new personal access token now. You won’t be able to see it again!
        </p-button>
      </div>
      <div v-for="(copyToken, index) in copyTokens" class="row">
        <div v-if="copyToken.access_token" class="w-100 tokens-new">
          <h5 class="col-md-12">New access token</h5>
          <div v-if="copyToken.access_token" class="col-md-10 token">
            {{ copyToken.access_token }}
          </div>
          <div v-if="copyToken.access_token" class="col-md-2">
            <p-button icon outline @click.native.prevent="copyText(copyToken.access_token)" type="success">
              <i class="fas fa-copy" />
            </p-button>
          </div>
        </div>
        <div v-else class="w-100">
          <div class="col-md-2">
            {{ copyToken.name }}
          </div>
          <div class="col-md-6">
            <span class="scopes_title">Scopes:</span>
            <span v-for="scope in copyToken.scopes" class="scope_name"> {{ scope }}, </span>
          </div>
          <div class="col-md-2">&nbsp;</div>
          <div class="col-md-2">
            <p-button type="danger" @click.prevent.native="destroy(copyToken, index)" round outline icon>
              <i class="fas fa-trash" />
            </p-button>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col text-center">
          <p-button type="success" @click.prevent.native="openGenerateModal()"> Generate new </p-button>
        </div>
      </div>
    </card>
    <ModalTemplate
      component-name="GenerateTokenModal"
      :data="{
        client: client,
        header: 'Generate new Token',
        scopes: public_scopes,
      }"
      :clicked="openGenerateTokenModal"
      @submit="addNewToken($event)"
      @close="closeGenerateModal()"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import ModalTemplate from '@/components/modals/ModalTemplate';
import GenerateDashboardTokenController from '@/controllers/PublicData/GenerateDashboardTokenController';
export default {
  name: 'Tokens',
  components: { ModalTemplate },
  props: {
    tokens: {
      type: Array,
    },
    client: {
      type: Object,
    },
    public_scopes: {
      type: Array,
    },
  },
  data() {
    return {
      copyTokens: [],
      openGenerateTokenModal: false,
      selectedToken: null,
      showInfoText: true,
      newToken: null,
    };
  },
  async mounted() {
    this.setCopyTokens();
  },
  methods: {
    setCopyTokens() {
      this.copyTokens = this.tokens;
    },
    async destroy(copyToken, index) {
      try {
        if (confirm('Are you sure, you want to delete this token?')) {
          await GenerateDashboardTokenController.destroy(copyToken.id);
          this.copyTokens.splice(index, 1);
          this.$notify({
            type: 'success',
            title: 'Access Token was deleted!',
          });
        }
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },
    openGenerateModal() {
      this.openGenerateTokenModal = true;
    },
    closeGenerateModal() {
      this.openGenerateTokenModal = false;
    },
    addNewToken(token) {
      this.newToken = token;
      this.showInfoText = true;
      this.copyTokens.unshift(token);
    },
    copyText: function (access_token) {
      let vm = this;
      this.$copyText(access_token).then(
        function (e) {
          vm.$notify({
            type: 'success',
            title: 'Access Token was copied!',
          });
        },
        function (e) {
          vm.$notify({
            type: 'danger',
            title: 'Can not copy',
          });
        }
      );
    },
  },
};
</script>

<style scoped>
.scopes_title {
  color: gray;
}
.scope_name {
  font-size: 1.2rem;
}
</style>
